"use client";

import { useState } from "react";
import Link from "next/link";

import { Logo } from "@/components/Logo";
import { IconButton } from "../components/buttons/IconButton";
import ImageContainer from "@/components/ImageContainer";
import { Menu } from "@/app/Menu";
import { useAuth } from "@/providers/AuthProvider";
import { getFullName } from "@/types/users/userWithoutTeachers";
import { USER_PROFILE_IMAGE_PROPS } from "./user/profile/UserProfileHeader";

export const Header = () => {
    const { user } = useAuth();

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const size = 24;

    return (
        <>
            <div className="header">
                <div className="header-left">
                    <IconButton
                        icon={isMenuOpen ? "close-menu" : "open-menu"}
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    />
                    {user && (
                        <Link href="/user/profile">
                            <ImageContainer
                                image={user?.image || null}
                                placeholderIconName={
                                    USER_PROFILE_IMAGE_PROPS.placeholderIconName
                                }
                                size={size}
                                containerClassName="!rounded-full !border-[1.5px]"
                                alt={getFullName(user)}
                            />
                        </Link>
                    )}
                </div>

                <Link href="/">
                    <Logo
                        logoSize={size}
                        fontSize={`${size}px`}
                        lineHeight={`${size - 7}px`}
                    />
                </Link>
            </div>
            <Menu isOpen={isMenuOpen} setIsOpen={setIsMenuOpen} />
        </>
    );
};
